export default __webpack_public_path__ + "static/media/latestNewsOne.eef1248c.png";